import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { apiFetch } from '../config/api';
import { toast } from '../components/ToastProvider';
import Icon from '../components/Icon';
import Calendar from '../components/Calendar';
import '../styles/Booking.css';
import '../styles/B2BTrainings.css';

const Booking = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, isAuthenticated } = useAuth();
  const { salon, gender } = location.state || {};
  const maleServices = [
    { id: 1, name: 'Strzyżenie męskie', price: 50, duration: 30 },
    { id: 2, name: 'Strzyżenie + stylizacja', price: 70, duration: 45 },
    { id: 3, name: 'Strzyżenie brody', price: 40, duration: 20 },
    { id: 4, name: 'Golenie brody', price: 35, duration: 25 },
    { id: 5, name: 'Strzyżenie + broda', price: 80, duration: 50 },
  ];

  const femaleServices = [
    { id: 6, name: 'Strzyżenie damskie', price: 80, duration: 45 },
    { id: 7, name: 'Strzyżenie + modelowanie', price: 120, duration: 60 },
    { id: 8, name: 'Farbowanie', price: 150, duration: 90 },
    { id: 9, name: 'Baleyage', price: 200, duration: 120 },
    { id: 10, name: 'Keratynowe prostowanie', price: 250, duration: 150 },
    { id: 11, name: 'Stylizacja okazjonalna', price: 100, duration: 60 },
  ];

  const [salonEmployees, setSalonEmployees] = useState([]);
  
  const employees = salonEmployees.length > 0 
    ? salonEmployees
        .filter(e => e.active === true || e.active === 1 || e.active === '1')
        .map(e => ({
          id: e.id,
          name: `${e.first_name} ${e.last_name}`,
          specialization: e.specialization || 'Fryzjer',
          rating: 4.8,
          experience: '3 lata'
        }))
    : [];

  const [salonInventory, setSalonInventory] = useState([]);
  const [salonHours, setSalonHours] = useState([]);

  useEffect(() => {
    if (!salon?.id) return;
    apiFetch(`/b2b/inventory/${salon.id}`)
      .then(items => setSalonInventory(items || []))
      .catch(() => setSalonInventory([]));
    apiFetch(`/salons/${salon.id}/services`)
      .then(data => {
        if (data?.length) setSalonServices(data);
      })
      .catch(() => {});
    apiFetch(`/salons/${salon.id}/employees`)
      .then(data => {
        if (data?.length) setSalonEmployees(data);
      })
      .catch(() => {});
    apiFetch(`/salons/${salon.id}/hours`)
      .then(data => setSalonHours(data || []))
      .catch(() => {});
    apiFetch(`/salons/${salon.id}`)
      .then(data => {
        if (data?.photo) {
          setSalonData(data);
        }
      })
      .catch(() => {});
  }, [salon?.id]);
  
  const [salonData, setSalonData] = useState(null);

  const clientProducts = salonInventory
    .filter(item => (item.stock || 0) > 0)
    .map((item, idx) => ({
      id: 'inv_' + idx,
      name: item.name || item.product_name,
      price: parseFloat(item.price) || 0,
      category: 'Produkt',
      desc: '',
      brand: 'HAIRKUS',
      stock: item.stock || 0,
    }));

  const [salonServices, setSalonServices] = useState([]);
  
  const maleServiceNames = ['strzyżenie męskie', 'strzyżenie brody', 'golenie brody', 'golenie', 'broda', 'barber'];
  const femaleServiceNames = ['strzyżenie damskie', 'farbowanie', 'baleyage', 'balayage', 'keratyna', 'koloryzacja', 'ombre', 'sombre', 'pasemka'];
  
  const filterServicesByGender = (services) => {
    if (!gender || gender === 'all') return services;
    
    return services.filter(service => {
      const serviceName = service.name.toLowerCase();
      
      if (gender === 'male') {
        return maleServiceNames.some(keyword => serviceName.includes(keyword)) ||
               (!femaleServiceNames.some(keyword => serviceName.includes(keyword)) && 
                (serviceName.includes('strzyżenie') || serviceName.includes('stylizacja')));
      } else if (gender === 'female') {
        return femaleServiceNames.some(keyword => serviceName.includes(keyword)) ||
               (!maleServiceNames.some(keyword => serviceName.includes(keyword)) && 
                (serviceName.includes('strzyżenie') || serviceName.includes('stylizacja')));
      }
      return true;
    });
  };
  
  const filteredSalonServices = filterServicesByGender(salonServices);
  
  const services = filteredSalonServices.length > 0
    ? filteredSalonServices.map(s => ({ id: s.id, name: s.name, price: parseFloat(s.price), duration: s.duration }))
    : (gender === 'male' ? maleServices : femaleServices);

  const [selectedServices, setSelectedServices] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectedDate, setSelectedDate] = useState('');
  const [selectedTime, setSelectedTime] = useState('');
  const [occupiedSlots, setOccupiedSlots] = useState([]);
  const [email, setEmail] = useState(user?.email || '');
  const [phone, setPhone] = useState(user?.phone || '');
  const [step, setStep] = useState(1);
  const [bookingConfirmed, setBookingConfirmed] = useState(null);
  const [isRestored, setIsRestored] = useState(false); 

  useEffect(() => {
    if (!isRestored) return; 
    
    const state = { selectedServices, selectedEmployee, selectedProducts, selectedDate, selectedTime, email, phone, step };
    sessionStorage.setItem('booking_state', JSON.stringify(state));
  }, [selectedServices, selectedEmployee, selectedProducts, selectedDate, selectedTime, email, phone, step, isRestored]);

  useEffect(() => {
    const saved = sessionStorage.getItem('booking_state');
    if (saved) {
      try {
        const state = JSON.parse(saved);
        setSelectedServices(state.selectedServices || []);
        setSelectedEmployee(state.selectedEmployee || null);
        setSelectedProducts(state.selectedProducts || []);
        setSelectedDate(state.selectedDate || '');
        setSelectedTime(state.selectedTime || '');
        setEmail(state.email || user?.email || '');
        setPhone(state.phone || user?.phone || '');
        setStep(state.step || 1);
        console.log('Restored booking state:', state); 
      } catch (error) {
        console.error('Error restoring state:', error);
      }
    } else if (user) {
      setEmail(user.email || '');
      setPhone(user.phone || '');
    }
    
    setIsRestored(true);

  }, [user]);

  useEffect(() => {
    if (user && (!email || !phone)) {
      if (!email && user.email) setEmail(user.email);
      if (!phone && user.phone) setPhone(user.phone);
    }
  }, [user, email, phone]);

  useEffect(() => {
    if (!salon?.id) return;
    
    apiFetch(`/salons/${salon.id}/employees`)
      .then(data => setSalonEmployees(data || []))
      .catch(() => setSalonEmployees([]));
  }, [salon?.id]);

  useEffect(() => {
    const fetchOccupiedSlots = async () => {
      if (!selectedDate || !salon) {
        setOccupiedSlots([]);
        return;
      }

      try {
        const params = new URLSearchParams({
          salon: salon.name.replace(/\s+/g, '_'),
          date: selectedDate,
        });

        if (gender) {
          params.append('gender', gender);
        }

        if (selectedEmployee) {
          params.append('employee', selectedEmployee.name.replace(/\s+/g, '_'));
        }

        const data = await apiFetch(`/bookings/availability?${params}`);
        setOccupiedSlots(data.occupiedSlots || []);
      } catch (err) {
        console.error('Error fetching availability:', err);
        setOccupiedSlots([]);
      }
    };

    fetchOccupiedSlots();
  }, [selectedDate, selectedEmployee, salon, gender]);

  const getMinDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const getBlockedTimeSlots = () => {
    const blocked = [...occupiedSlots];
    
    if (selectedDate) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      
      const selected = new Date(selectedDate);
      selected.setHours(0, 0, 0, 0);
      
      if (selected.getTime() === today.getTime()) {
        const now = new Date();
        const currentHour = now.getHours();
        const currentMinute = now.getMinutes();
        
        timeSlots.forEach(slot => {
          const [hour, minute] = slot.split(':').map(Number);
          if (hour < currentHour || (hour === currentHour && minute <= currentMinute)) {
            if (!blocked.includes(slot)) {
              blocked.push(slot);
            }
          }
        });
      }
    }
    
    return blocked;
  };

  const timeSlots = [
    '09:00', '09:30', '10:00', '10:30', '11:00', '11:30',
    '12:00', '12:30', '13:00', '13:30', '14:00', '14:30',
    '15:00', '15:30', '16:00', '16:30', '17:00', '17:30',
  ];

  const toggleService = (service) => {
    setSelectedServices(prev => prev.find(s => s.id === service.id) 
      ? prev.filter(s => s.id !== service.id) 
      : [...prev, service]
    );
  };

  const toggleProduct = (product) => {
    setSelectedProducts(prev => prev.find(p => p.id === product.id)
      ? prev.filter(p => p.id !== product.id)
      : [...prev, product]
    );
  };

  const calcServicesTotal = () => selectedServices.reduce((sum, s) => sum + s.price, 0);
  const calcProductsTotal = () => selectedProducts.reduce((sum, p) => sum + p.price, 0);
  const calcTotal = () => calcServicesTotal() + calcProductsTotal();
  const calcDuration = () => selectedServices.reduce((sum, s) => sum + s.duration, 0);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    let phoneDigits = phone.replace(/\D/g, '');
    
    if (phoneDigits.startsWith('48')) {
      phoneDigits = phoneDigits.substring(2);
    }
    
    if (phoneDigits.length < 9) {
      toast.error('Numer telefonu musi składać się z 9 cyfr');
      return;
    }
    
    if (phoneDigits.length > 9) {
      toast.error('Numer telefonu może mieć maksymalnie 9 cyfr');
      return;
    }
    
    if (!isAuthenticated) {
      sessionStorage.setItem('booking_state', JSON.stringify({
        selectedServices,
        selectedEmployee,
        selectedProducts,
        selectedDate,
        selectedTime,
        email,
        phone,
        step,
      }));

      navigate('/login', { 
        state: { 
          from: {
            pathname: location.pathname,
            state: { salon, gender }
          }
        } 
      });
      return;
    }

    try {
      const booking = await apiFetch('/bookings', {
        method: 'POST',
        body: JSON.stringify({
          salon,
          services:       selectedServices,
          employee:       selectedEmployee,
          products:       selectedProducts,
          date:           selectedDate,
          time:           selectedTime,
          email:          email || user.email,
          phone:          phone || user.phone,
          total:          calcTotal(),
          servicesTotal:  calcServicesTotal(),
          productsTotal:  calcProductsTotal(),
          duration:       calcDuration(),
          gender:         gender, 
        }),
      });

      sessionStorage.removeItem('booking_state');
      
      setBookingConfirmed({
        ...booking,
        salon: salon, 
        date: selectedDate,
        time: selectedTime,
        services: selectedServices,
        employee: selectedEmployee,
        products: selectedProducts,
      });
      
      toast.success('Rezerwacja wysłana! Szczegóły poniżej.');
    } catch (err) {
      toast.error(err.message || 'Błąd podczas składania rezerwacji');
      return;
    }
  };

  const blockedSlots = getBlockedTimeSlots();

  if (bookingConfirmed) {
    const b = bookingConfirmed;
    return (
      <div className="booking-container">
        <div className="booking-wrapper" style={{maxWidth:'640px'}}>
          <div className="booking-confirmed-screen">
            <div className="confirmed-icon">
              <Icon name="confirmed" color="#10b981" size="3x" />
            </div>
            <h1>Rezerwacja złożona!</h1>
            <p className="confirmed-subtitle">Twoja prośba o wizytę została wysłana do salonu.</p>

            <div className="confirmed-email-box">
              <Icon name="email" color="#1e3c72" style={{marginRight:'10px', flexShrink:0}} />
              <div>
                <strong>Potwierdzenie wysłane na:</strong>
                <span>{b.email}</span>
              </div>
            </div>

            <div className="confirmed-details">
              <div className="confirmed-detail-row">
                <Icon name="salon" color="#1e3c72" style={{marginRight:'10px'}} />
                <div><label>Salon</label><strong>{b.salon?.name}</strong></div>
              </div>
              <div className="confirmed-detail-row">
                <Icon name="calendar" color="#1e3c72" style={{marginRight:'10px'}} />
                <div><label>Termin</label><strong>{b.date}, {b.time}</strong></div>
              </div>
              <div className="confirmed-detail-row">
                <Icon name="service" color="#1e3c72" style={{marginRight:'10px'}} />
                <div>
                  <label>Usługi</label>
                  <strong>{b.services?.map(s => s.name).join(', ')}</strong>
                </div>
              </div>
              {b.employee && (
                <div className="confirmed-detail-row">
                  <Icon name="user" color="#1e3c72" style={{marginRight:'10px'}} />
                  <div><label>Fryzjer</label><strong>{b.employee.name}</strong></div>
                </div>
              )}
              <div className="confirmed-detail-row confirmed-total">
                <Icon name="money" color="#059669" style={{marginRight:'10px'}} />
                <div><label>Do zapłaty</label><strong style={{color:'#059669',fontSize:'1.2em'}}>{b.total} zł</strong></div>
              </div>
            </div>

            <div className="confirmed-status-info">
              <Icon name="pending" color="#f59e0b" style={{marginRight:'8px'}} />
              Status: <strong>Oczekuje na potwierdzenie salonu</strong>
              <span>Salon potwierdzi lub zaproponuje inny termin</span>
            </div>

            <div className="confirmed-actions">
              <button className="confirmed-btn-primary" onClick={() => navigate('/dashboard/client')}>
                <Icon name="dashboard" style={{marginRight:'8px'}} />Moje rezerwacje
              </button>
              <button className="confirmed-btn-secondary" onClick={() => {
                setBookingConfirmed(null);
                setStep(1);
              }}>
                <Icon name="add" style={{marginRight:'8px'}} />Nowa rezerwacja
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (user && user.role !== 'client') {
    return (
      <div className="booking-container">
        <div className="booking-wrapper">
          <div style={{
            textAlign: 'center', padding: '80px 40px',
            background: 'white', borderRadius: '16px',
            boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
            marginTop: '40px',
          }}>
            <div style={{ fontSize: '4em', marginBottom: '20px' }}></div>
            <h2 style={{ color: '#1e3c72', marginBottom: '10px' }}>Brak dostępu</h2>
            <p style={{ color: '#666', marginBottom: '30px', fontSize: '1.1em' }}>
              Konta salonowe, administratorskie i franczyzobiorców nie mogą rezerwować wizyt.
            </p>
            <button
              onClick={() => navigate(-1)}
              style={{
                padding: '12px 30px', background: 'linear-gradient(135deg, #1e3c72, #2a5298)',
                color: 'white', border: 'none', borderRadius: '10px',
                fontWeight: '700', fontSize: '1em', cursor: 'pointer',
              }}
            >
              ← Wróć
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="booking-container">
      <div className="booking-wrapper">
        <div className="booking-header">
          <div style={{display:'flex', gap:'25px', alignItems:'flex-start', marginBottom:'20px'}}>
            <div style={{flex:1}}>
              <h1 style={{margin:'0 0 8px 0'}}>Rezerwacja wizyty</h1>
              <p className="salon-name">{salon?.name || 'Salon'}</p>
              <p className="salon-address"><Icon name="location" color="#1e3c72" style={{marginRight:'5px'}} /> {salon?.address}</p>
              {salonHours.length > 0 && (() => {
                const daysFullNames = {mon:'Poniedziałek',tue:'Wtorek',wed:'Środa',thu:'Czwartek',fri:'Piątek',sat:'Sobota',sun:'Niedziela'};
                const hours = ['mon','tue','wed','thu','fri','sat','sun'].map(day => {
                  const h = salonHours.find(x => x.day_key === day);
                  return h && !h.is_closed ? { day, time: `${h.open_time?.slice(0,5)}-${h.close_time?.slice(0,5)}` } : null;
                }).filter(Boolean);
                
                return (
                  <div style={{marginTop:'12px', fontSize:'0.85em', color:'#6b7280', lineHeight:'1.6', textAlign:'center'}}>
                    <div style={{display:'flex', alignItems:'center', justifyContent:'center', gap:'6px', marginBottom:'6px'}}>
                      <Icon name="clock" color="#1e3c72" size="sm" />
                      <strong style={{color:'#374151'}}>Godziny otwarcia:</strong>
                    </div>
                    <div style={{display:'flex', flexWrap:'wrap', justifyContent:'center', gap:'8px 16px'}}>
                      {hours.map((h, i) => (
                        <span key={i}>
                          <strong style={{color:'#374151'}}>{daysFullNames[h.day]}:</strong> {h.time}
                          {i < hours.length - 1 && <span style={{color:'#d1d5db', margin:'0 4px'}}>|</span>}
                        </span>
                      ))}
                    </div>
                  </div>
                );
              })()}
            </div>
            {(salonData?.photo || salon?.photo) && (
              <img 
                src={salonData?.photo || salon.photo} 
                alt={salon.name}
                style={{
                  width:'140px', 
                  height:'140px', 
                  objectFit:'cover', 
                  borderRadius:'10px', 
                  border:'2px solid #e5e7eb',
                  boxShadow:'0 2px 8px rgba(0,0,0,0.1)',
                  flexShrink: 0
                }}
              />
            )}
          </div>
        </div>

        <div className="booking-steps">
          {[
            { num: 1, label: 'Usługi' },
            { num: 2, label: 'Pracownik' },
            { num: 3, label: 'Produkty' },
            { num: 4, label: 'Termin' },
            { num: 5, label: 'Kontakt' },
          ].map(({ num, label }, idx) => (
            <React.Fragment key={num}>
              <div className={`step ${step >= num ? 'active' : ''} ${step > num ? 'completed' : ''}`}>
                <div className="step-number">{num}</div>
                <div className="step-label">{label}</div>
              </div>
              {idx < 4 && <div className="step-divider"></div>}
            </React.Fragment>
          ))}
        </div>

        <div className="booking-content">
          <div className="booking-main">
            
            {step === 1 && (
              <div className="services-section">
                <h2>Wybierz usługi</h2>
                <div className="services-grid">
                  {services.map(service => (
                    <div
                      key={service.id}
                      className={`service-card ${selectedServices.find(s => s.id === service.id) ? 'selected' : ''}`}
                      onClick={() => toggleService(service)}
                    >
                      <div className="service-info">
                        <h3>{service.name}</h3>
                        <p className="service-duration"><Icon name="timer" style={{marginRight:"4px"}} /> {service.duration} min</p>
                      </div>
                      <div className="service-price">{service.price} zł</div>
                      <div className="service-checkbox">
                        {selectedServices.find(s => s.id === service.id) && ''}
                      </div>
                    </div>
                  ))}
                </div>
                <button className="next-button" disabled={!selectedServices.length} onClick={() => setStep(2)}>
                  Dalej - Wybierz pracownika
                </button>
              </div>
            )}

            {step === 2 && (
              <div className="employee-section">
                <h2>Wybierz pracownika</h2>
                <div className="employees-grid">
                  {employees.map(emp => (
                    <div
                      key={emp.id}
                      className={`employee-card ${selectedEmployee?.id === emp.id ? 'selected' : ''}`}
                      onClick={() => setSelectedEmployee(emp)}
                    >
                      <div className="employee-avatar">
                        {emp.name.split(' ').map(n => n[0]).join('')}
                      </div>
                      <div className="employee-info">
                        <h3>{emp.name}</h3>
                        <p className="employee-spec"> {emp.specialization}</p>
                        <p className="employee-exp"><Icon name="calendar" style={{marginRight:'7px'}} /> {emp.experience}</p>
                        <div className="employee-rating"><Icon name="star" color="#f59e0b" style={{marginRight:'5px'}} /> {emp.rating} / 5.0</div>
                      </div>
                      <div className="employee-checkbox">
                        {selectedEmployee?.id === emp.id && ''}
                      </div>
                    </div>
                  ))}
                </div>
                <div className="step-buttons">
                  <button className="back-button" onClick={() => setStep(1)}>← Wróć</button>
                  <button className="next-button" disabled={!selectedEmployee} onClick={() => setStep(3)}>
                    Dalej - Produkty
                  </button>
                </div>
              </div>
            )}

            {step === 3 && (
              <div className="products-section">
                <div className="products-section-header">
                  <h2><Icon name="product" style={{marginRight:'10px'}} />Produkty do zakupu</h2>
                  <p className="products-subtitle">Profesjonalne produkty dostępne do odbioru po wizycie</p>
                </div>
                {clientProducts.length === 0 ? (
                  <div style={{textAlign:'center', padding:'40px', color:'#9ca3af'}}>
                    <Icon name="package" color="#d1d5db" size="2x" />
                    <p style={{marginTop:'12px'}}>Brak produktów dostępnych w tym salonie</p>
                  </div>
                ) : (
                  <div className="products-grid">
                    {clientProducts.map(prod => {
                      const isSelected = !!selectedProducts.find(p => p.id === prod.id);
                      const lowStock = prod.stock > 0 && prod.stock <= 3;
                      return (
                        <div
                          key={prod.id}
                          className={`product-card ${isSelected ? 'selected' : ''}`}
                          onClick={() => toggleProduct(prod)}
                        >
                          <div className="product-cat-badge">{prod.category}</div>
                          <div className="product-info">
                            <h3>{prod.name}</h3>
                            <p className="product-brand">{prod.brand}</p>
                            {prod.desc && <p className="product-desc">{prod.desc}</p>}
                          </div>
                          <div className="product-card-footer">
                            <span className="product-price">{prod.price} zł</span>
                            <div className={`product-stock-badge ${lowStock ? 'stock-low' : 'stock-ok'}`}>
                              <Icon name={lowStock ? 'warning' : 'confirmed'} style={{marginRight:'4px',fontSize:'0.8em'}} />
                              {prod.stock} szt.
                            </div>
                          </div>
                          {isSelected && (
                            <div className="product-selected-overlay">
                              <Icon name="check" color="white" size="lg" />
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                )}
                <div className="step-buttons">
                  <button className="back-button" onClick={() => setStep(2)}>← Wróć</button>
                  <button className="next-button" onClick={() => setStep(4)}>
                    Dalej - Wybierz termin
                  </button>
                </div>
              </div>
            )}

            {step === 4 && (
              <div className="datetime-section">
                <h2>Wybierz datę i godzinę</h2>
                <div className="date-picker-visual">
                  <label>Data wizyty:</label>
                  <Calendar selectedDate={selectedDate} onDateSelect={setSelectedDate} minDate={getMinDate()} />
                </div>
                {selectedDate && (
                  <div className="time-picker">
                    <label>Godzina wizyty:</label>
                    <div className="time-slots">
                      {timeSlots.map(time => {
                        const isBlocked = blockedSlots.includes(time);
                        return (
                          <div
                            key={time}
                            className={`time-slot ${selectedTime === time ? 'selected' : ''} ${isBlocked ? 'blocked' : ''}`}
                            onClick={() => !isBlocked && setSelectedTime(time)}
                          >
                            {time}
                            {isBlocked && <span className="blocked-icon"><Icon name="cancelled" color="#9ca3af" style={{marginRight:'5px'}} /></span>}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
                <div className="step-buttons">
                  <button className="back-button" onClick={() => setStep(3)}>← Wróć</button>
                  <button className="next-button" disabled={!selectedDate || !selectedTime} onClick={() => setStep(5)}>
                    Dalej - Dane kontaktowe
                  </button>
                </div>
              </div>
            )}

            {step === 5 && (
              <div className="contact-section">
                <h2>Twoje dane kontaktowe</h2>
                <form onSubmit={handleSubmit}>
                  <div className="form-group">
                    <label>Email:</label>
                    <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
                  </div>
                  <div className="form-group">
                    <label>Telefon:</label>
                    <input 
                      type="tel" 
                      value={phone} 
                      onChange={(e) => {
                        const input = e.target.value;
                        let digits = input.replace(/\D/g, '');
                        if (digits.startsWith('48')) {
                          digits = digits.substring(2);
                        }
                        if (digits.length > 9) {
                          digits = digits.substring(0, 9);
                        }
                        let formatted = '+48';
                        if (digits.length > 0) {
                          formatted += ' ' + digits.substring(0, 3);
                        }
                        if (digits.length > 3) {
                          formatted += ' ' + digits.substring(3, 6);
                        }
                        if (digits.length > 6) {
                          formatted += ' ' + digits.substring(6, 9);
                        }
                        setPhone(formatted);
                      }}
                      placeholder="+48 123 456 789"
                      title="Podaj pełny numer telefonu (9 cyfr)"
                      required 
                    />
                    <p style={{fontSize:'0.85em', color:'#6b7280', marginTop:'4px'}}>
                      Format: +48 123 456 789 (wymagane 9 cyfr)
                    </p>
                  </div>
                  <div className="info-box">
                    <p><Icon name="email" color="#1e3c72" style={{marginRight:'7px'}} />Otrzymasz email z potwierdzeniem</p>
                    <p><Icon name="phone" style={{marginRight:'5px'}} /> Salon może Cię skontaktować</p>
                  </div>
                  <div className="step-buttons">
                    <button type="button" className="back-button" onClick={() => setStep(4)}>← Wróć</button>
                    <button type="submit" className="submit-button" disabled={!email || !phone}>
                      Potwierdź rezerwację
                    </button>
                  </div>
                </form>
              </div>
            )}
          </div>

          <div className="booking-summary">
            <h3>Podsumowanie</h3>
            {selectedServices.length > 0 ? (
              <>
                <div className="summary-section">
                  <h4>Usługi:</h4>
                  {selectedServices.map(s => (
                    <div key={s.id} className="summary-item">
                      <span>{s.name}</span><span>{s.price} zł</span>
                    </div>
                  ))}
                  <div className="summary-subtotal">
                    <span>Razem usługi:</span><span>{calcServicesTotal()} zł</span>
                  </div>
                </div>
                {selectedEmployee && (
                  <div className="summary-section">
                    <h4>Pracownik:</h4>
                    <p><Icon name="user" style={{marginRight:'7px'}} /> {selectedEmployee.name}</p>
                    <p className="summary-small"><Icon name="star" color="#f59e0b" style={{marginRight:'5px'}} /> {selectedEmployee.rating} / 5.0</p>
                  </div>
                )}
                {selectedProducts.length > 0 && (
                  <div className="summary-section">
                    <h4>Produkty:</h4>
                    {selectedProducts.map(p => (
                      <div key={p.id} className="summary-item">
                        <span>{p.name}</span><span>{p.price} zł</span>
                      </div>
                    ))}
                    <div className="summary-subtotal">
                      <span>Razem produkty:</span><span>{calcProductsTotal()} zł</span>
                    </div>
                  </div>
                )}
                <div className="summary-total">
                  <div className="summary-item">
                    <strong>Czas:</strong><strong>{calcDuration()} min</strong>
                  </div>
                  <div className="summary-item total-price">
                    <strong>Do zapłaty:</strong><strong>{calcTotal()} zł</strong>
                  </div>
                </div>
                {selectedDate && (
                  <div className="summary-section">
                    <h4>Termin:</h4>
                    <p><Icon name="calendar" style={{marginRight:'7px'}} /> {selectedDate}</p>
                    {selectedTime && <p><Icon name="clock" style={{marginRight:"4px"}} /> {selectedTime}</p>}
                  </div>
                )}
                {email && (
                  <div className="summary-section">
                    <h4>Kontakt:</h4>
                    <p><Icon name="email" color="#1e3c72" style={{marginRight:'5px'}} /> {email}</p>
                    {phone && <p><Icon name="phone" style={{marginRight:'5px'}} /> {phone}</p>}
                  </div>
                )}
              </>
            ) : (
              <p className="empty-summary">Wybierz usługi</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Booking;